export default function useFormatNumber() {
    const formatPhoneNumbers0800 = (text) => {
      return text.replace(
        /\b0800[-\s]?(\d{3})[-\s]?(\d{4})\b/g,
        (_, part1, part2) => {
          const formattedNumber = `0800-${part1}-${part2}`;
          return `<a href="tel:+55${formattedNumber.replace(
            /-/g,
            ""
          )}">${formattedNumber}</a>`;
        }
      );
    };

    return { formatPhoneNumbers0800 };
}